import { Box, Button, FormLabel, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react'
import { getI18n } from "../../utils/intl";
import { useIntl } from 'react-intl';
import styles from "./styles";
import { AlertMessages, FileDropzone, FormActionButtons, FormButtonGroup, FormDialog, FormSelect, FormTextField, Loading, RadioGroupSection, Switch } from '../../components';
import { MAX_FILE_SIZE, getFileExtension, convertFormDataToPayload, validateFormFields, EMAIL_SETTINGS_BUTTON_SMTP, EMAIL_SETTINGS_BUTTON_SMTPS, EMAIL_SETTINGS_BUTTON_SMTPTLS, EMAIL_SETTINGS_RADIO_SERVER, EMAIL_SETTINGS_RADIO_MUTUAL, SERVER_CERTIFICATE, CLIENT_CERTIFICATE } from './utils';
import { isArray } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { getConfig, getIsPortalAdmin } from '../../reducers/portalConfig';
import get from 'lodash/get';
import { createEmailSettings, fetchEmailSettingsCertificates, fetchEmailSettingsDetails, replaceClientCertificate, replaceEmailSettings, validateClientCertificate } from '../../actions/emailSettings';
import { getClientCertificateError, getCertificatesData, getInvalidClientCertificateError, getEmailSettingsCreateError, getEmailSettingsCreateValidationError, getEmailSettingsDetails, getIsLoading, getClientCertificateSuccess } from '../../reducers/emailSettings';
import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import GenerateCsrCertificate from './GenerateCsrCertificate';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';

const CreatePageContent = (props) => {
  const {
    intl,
    handleServerProperties,
    serverProperties,
    handleEnabled,
    enabled,
    classes,
    isFileValidationServer,
    fileValidationMessageServer,
    handleServerFiles,
    serverFile,
    onRemoveServerFile,
    onRemoveClientFile,
    handleServerAuthCredentials,
    serverAuthCredentials,
    handleUpdateEmailSettings,
    fieldNameEmptyError,
    certificatesData,
    setShowCsr,
    handleClientFiles,
    clientFile,
    isFileValidationClient,
    fileValidationMessageClient,
    aliasFieldNameError,
    history,
  } = props

  const emailSettingsProtocalOptions = [
    {
      name: intl.getI18nMessage("label.email.settings.protocol.smtp"),
      uuid: EMAIL_SETTINGS_BUTTON_SMTP,
    },
    {
      name: intl.getI18nMessage("label.email.settings.protocol.smtps"),
      uuid: EMAIL_SETTINGS_BUTTON_SMTPS,
    },
    {
      name: intl.getI18nMessage("label.email.settings.protocol.smtp.tls"),
      uuid: EMAIL_SETTINGS_BUTTON_SMTPTLS,
    },
  ];

  const emailSettingsAuthTypesOptions = [
    {
      name: intl.getI18nMessage("label.email.settings.auth.type.server"),
      id: EMAIL_SETTINGS_RADIO_SERVER,
      description: intl.getI18nMessage("label.email.settings.auth.type.server.desc"),
    },
    {
      name: intl.getI18nMessage("label.email.settings.auth.type.mutual"),
      id: EMAIL_SETTINGS_RADIO_MUTUAL,
      description: intl.getI18nMessage("label.email.settings.auth.type.mutual.desc"),
    },
  ];

  const emptyFieldName = <span className={classes.textError}>{intl.getI18nMessage("error.field.mandatory")}</span>;

  const isDisableSaveButton = useMemo(() => {
    if (serverProperties.host === "" || serverProperties.port === "" ||
      serverProperties.defaultSenderAddress === "" ||
      serverProperties.verificationEmail === ""
    ) {
      return true;
    }
  }, [serverProperties])

  const filterCertificates = certificatesData?.filter((certificate) =>
    certificate.uuid === serverProperties.clientCertUuid);

  return (
    <>
      <form className={classes.formSection}>
        <Box>
          <Box className={classes.flex}>
            <Typography data-apim-test="email-settings-smtp-service-label" className={classes.fontContainer} variant='subtitle2'>{intl.getI18nMessage("label.email.settings.smtp.service.title")}</Typography>
            <Switch
              onChange={handleEnabled}
              checked={enabled}
              id="email-settings-smtp-service-switch"
            />
          </Box>
          <hr />
          <Typography variant='subtitle2'>{intl.getI18nMessage("label.email.settings.smtp.service.description")}</Typography>
        </Box>
        {
          enabled &&
          <>
            <FormButtonGroup
              name={intl.getI18nMessage("label.email.settings.protocol.title")}
              data={emailSettingsProtocalOptions}
              handleChange={(value) => handleServerProperties("protocol", value)}
              value={serverProperties.protocol}
              id="email-settings-protocol"
            />
            <hr className={classes.horizontaLine} />
            {
              (serverProperties.protocol === EMAIL_SETTINGS_BUTTON_SMTPS ||
                serverProperties.protocol === EMAIL_SETTINGS_BUTTON_SMTPTLS) &&
              <>
                <FormLabel>
                  {intl.getI18nMessage("label.email.settings.auth.type.title")}
                </FormLabel>
                <RadioGroupSection
                  data={emailSettingsAuthTypesOptions}
                  onChange={(e) => handleServerProperties('sslAuthType', e.target.value)}
                  selected={serverProperties.sslAuthType}
                  id="email-settings-ssl-auth-type"
                />
                <Box>
                  <Typography className={classes.serverCertificateTitle} variant='subtitle2'>{intl.getI18nMessage("label.email.settings.server.certificate.title")}</Typography>
                  <FileDropzone
                    id='email-settings-server-certificate'
                    defaultSelectedText={serverProperties?.certificateName || "No files selected"}
                    labelClass={classes.fileDropLabelClass}
                    helperText={intl.getI18nMessage("label.email.settings.file.upload.helptext")}
                    title={intl.getI18nMessage('label.auth.upload.trust.certificate')}
                    showSelectedFiles={true}
                    isValidation={isFileValidationServer}
                    validationMessage={fileValidationMessageServer}
                    handleFiles={handleServerFiles}
                    selectedFiles={serverFile}
                    onRemoveFile={onRemoveServerFile}
                    defaultUploaderText={intl.getI18nMessage(
                      'label.custom.pages.upload',
                    )}
                  />
                </Box>
                {
                  serverProperties.sslAuthType === EMAIL_SETTINGS_RADIO_MUTUAL &&
                  <Box>
                    <Box className={classes.flex}>
                      <Typography data-apim-test='email-settings-client-certificate-title' className={classes.fontContainer} variant='subtitle2'>{intl.getI18nMessage("label.email.settings.client.certificate.title")}</Typography>
                      <Button
                        data-apim-test='email-settings-create-csr-button'
                        variant='contained'
                        className={classes.submitButton}
                        color='secondary'
                        onClick={() => setShowCsr(true)}
                      >
                        {intl.getI18nMessage("label.email.settings.create.csr.button.text")}
                      </Button>
                    </Box>
                    <FormSelect
                      id='email-settings-alias-name'
                      name={intl.getI18nMessage("label.email.settings.client.certificate.alias.title")}
                      defaultText={intl.getI18nMessage("label.email.settings.client.certificate.select.alias.default.text")}
                      data={certificatesData?.map((value) => ({
                        uuid: value.uuid,
                        name: value.aliasName,
                      }))}
                      handleChange={(e) => handleServerProperties("clientCertUuid", e.target.value)}
                      value={serverProperties.clientCertUuid}
                      helperText={aliasFieldNameError && emptyFieldName}
                      error={aliasFieldNameError}
                    />
                    <FileDropzone
                      id='email-settings-client-certificate'
                      defaultSelectedText={filterCertificates && filterCertificates[0]?.certificateName || "No files selected"}
                      labelClass={classes.fileDropLabelClass}
                      helperText={intl.getI18nMessage("label.email.settings.file.upload.helptext")}
                      title={intl.getI18nMessage('label.auth.upload.trust.certificate')}
                      showSelectedFiles={true}
                      isValidation={isFileValidationClient}
                      validationMessage={fileValidationMessageClient}
                      handleFiles={handleClientFiles}
                      selectedFiles={clientFile}
                      onRemoveFile={onRemoveClientFile}
                      defaultUploaderText={intl.getI18nMessage(
                        'label.custom.pages.upload',
                      )}
                    />
                  </Box>
                }
              </>
            }
            <Box>
              <Typography data-apim-test="email-settings-connection-details-title" variant='h4'>{intl.getI18nMessage("label.auth.connection.details")}</Typography>
              <FormTextField
                id="email-settings-smtp-host"
                name={intl.getI18nMessage("label.email.settings.smtp.host.title")}
                helperText={fieldNameEmptyError.host ? emptyFieldName : intl.getI18nMessage("label.email.settings.smtp.host.helptext")}
                handleChange={(value) => handleServerProperties("host", value)}
                value={serverProperties.host}
                error={fieldNameEmptyError.host}
              />
              <FormTextField
                id="email-settings-smtp-port"
                name={intl.getI18nMessage("label.email.settings.smtp.port.title")}
                handleChange={(value) => handleServerProperties("port", value)}
                value={serverProperties.port}
                helperText={fieldNameEmptyError.port && emptyFieldName}
                error={fieldNameEmptyError.port}
              />
              <FormTextField
                id="email-settings-smtp-username"
                name={intl.getI18nMessage("label.username")}
                helperText={intl.getI18nMessage("label.email.settings.connection.username.helptext")}
                handleChange={(value) => handleServerAuthCredentials("username", value)}
                value={serverAuthCredentials.username}
                optional={true}
              />
              <FormTextField
                id="email-settings-smtp-password"
                type="password"
                name={intl.getI18nMessage("label.user.account.setup.password.label")}
                helperText={intl.getI18nMessage("label.email.settings.connection.password.helptext")}
                handleChange={(value) => handleServerAuthCredentials("password", value)}
                value={serverAuthCredentials.password}
                optional={true}
              />
            </Box>
            <Box>
              <Typography data-apim-test="email-settings-email-options-title" variant='h4'>{intl.getI18nMessage("label.email.settings.email.options.title")}</Typography>
              <FormTextField
                id="email-settings-senders-name"
                name={intl.getI18nMessage("label.email.settings.email.options.senders.name")}
                helperText={intl.getI18nMessage("label.email.settings.email.options.senders.name.helptext")}
                handleChange={(value) => handleServerProperties("defaultSenderName", value)}
                value={serverProperties.defaultSenderName}
                optional={true}
              />
              <FormTextField
                id="email-settings-senders-email"
                name={intl.getI18nMessage("label.email.settings.email.options.senders.email")}
                helperText={fieldNameEmptyError.defaultSenderAddress ? emptyFieldName : intl.getI18nMessage("label.email.settings.email.options.senders.email.helptext")}
                handleChange={(value) => handleServerProperties("defaultSenderAddress", value)}
                value={serverProperties.defaultSenderAddress}
                error={fieldNameEmptyError.defaultSenderAddress}
              />
              <FormTextField
                id="email-settings-bounce-email"
                name={intl.getI18nMessage("label.email.settings.email.options.bounce.email")}
                helperText={intl.getI18nMessage("label.email.settings.email.options.bounce.email.helptext")}
                handleChange={(value) => handleServerProperties("bounceAddress", value)}
                value={serverProperties.bounceAddress}
                optional={true}
              />
              <FormTextField
                id="email-settings-verification-email"
                name={intl.getI18nMessage("label.email.settings.email.options.verification.email")}
                helperText={fieldNameEmptyError.verificationEmail ? emptyFieldName : intl.getI18nMessage("label.email.settings.email.options.verification.email.helptext")}
                handleChange={(value) => handleServerProperties("verificationEmail", value)}
                value={serverProperties.verificationEmail}
                error={fieldNameEmptyError.verificationEmail}
              />
            </Box>
          </>
        }
      </form>
      <FormActionButtons
        onNextClick={handleUpdateEmailSettings}
        nextText={intl.getI18nMessage('label.save.button')}
        onCancelClick={() => history.goBack()}
        isDisabled={isDisableSaveButton}
        cancelText={intl.getI18nMessage("label.cancel.button")}
        isContainerFooter
      />
    </>
  )
}

CreatePageContent.propTypes = {
  intl: PropTypes.func,
  handleServerProperties: PropTypes.func,
  serverProperties: PropTypes.object,
  handleEnabled: PropTypes.func,
  enabled: PropTypes.object,
  classes: PropTypes.object,
  isFileValidationServer: PropTypes.bool,
  fileValidationMessageServer: PropTypes.string,
  handleServerFiles: PropTypes.func,
  serverFile: PropTypes.object,
  onRemoveServerFile: PropTypes.func,
  onRemoveClientFile: PropTypes.func,
  handleServerAuthCredentials: PropTypes.func,
  serverAuthCredentials: PropTypes.object,
  handleUpdateEmailSettings: PropTypes.func,
  fieldNameEmptyError: PropTypes.object,
  certificatesData: PropTypes.array,
  setShowCsr: PropTypes.func,
  handleClientFiles: PropTypes.func,
  clientFile: PropTypes.object,
  isFileValidationClient: PropTypes.bool,
  fileValidationMessageClient: PropTypes.string,
  aliasFieldNameError: PropTypes.bool,
  history: PropTypes.object,
}


const EmailSettings = () => {
  const intl = getI18n(useIntl());
  const history = useHistory();

  const fileRequirements = {
    files: [],
    acceptFileTypes: '',
    maxFiles: 1,
    error: false,
    helperText: intl.getI18nMessage("label.email.settings.file.upload.helptext"),
    maxSize: MAX_FILE_SIZE,
  }

  const [enabled, setEnabled] = useState(false);
  const [serverFile, setServerFile] = useState({ ...fileRequirements, files: [] });
  const [clientFile, setClientFile] = useState({ ...fileRequirements, files: [] });
  const [isFileValidationServer, setIsFileValidationServer] = useState(false);
  const [fileValidationMessageServer, setFileValidationMessageServer] = useState('');
  const [isFileValidationClient, setIsFileValidationClient] = useState(false);
  const [fileValidationMessageClient, setFileValidationMessageClient] = useState('');
  const [aliasFieldNameError, setAliasFieldNameError] = useState(false);
  const [serverProperties, setServerProperties] = useState({
    host: "",
    port: "",
    defaultSenderAddress: "",
    protocol: "",
    sslAuthType: "",
    defaultSenderName: "",
    bounceAddress: "",
    type: "SMTP",
    clientCertUuid: "",
    verificationEmail: "",
    certificateName: "",
    certificateContent: "",
  })

  const [serverAuthCredentials, setServerAuthCredentials] = useState({
    username: "",
    password: "",
    type: "BASICAUTH",
  })
  const [clientCertificatePayload, setClientCertificatePayload] = useState({
    certificateName: "",
    certificateContent: "",
  })

  const [fieldNameEmptyError, setFieldNameEmptyError] = useState({
    host: false,
    port: false,
    defaultSenderAddress: false,
    verificationEmail: false,
  })

  const [showDialog, setShowDialog] = useState(false);
  const [showCsr, setShowCsr] = useState(false);
  const [showAlert, setShowAlert] = useState({
    show: false,
    variant: "",
    message: "",
  })

  const isLoading = useSelector((state) => getIsLoading(state));
  const getTenantPrefix = useSelector((state) => getConfig(state));
  const emailSettingsError = useSelector((state) =>
    getEmailSettingsCreateError(state));
  const emailSettingsValidationError = useSelector((state) =>
    getEmailSettingsCreateValidationError(state));
  const inValidClientCertificateError = useSelector((state) =>
    getInvalidClientCertificateError(state));
  const emailSettingsDetails = useSelector((state) => getEmailSettingsDetails(state));
  const certificatesData = useSelector((state) => getCertificatesData(state));
  const clientCertificateError = useSelector((state) => getClientCertificateError(state));
  const clientCertificateErrorCode = clientCertificateError?.detail.errorCode;
  const clientCertificateErrorMessage = clientCertificateError?.message.value;
  const emailSettingsSuccessMessage = useSelector((state) => get(state, 'emailSettings.emailSettingsData.data.respMsg'));

  const formData = {
    enabled: enabled,
    serverProperties: serverProperties,
    serverAuthCredentials: serverAuthCredentials,
    uuid: get(getTenantPrefix, 'portal.tenantPrefix'),
  }

  const dispatch = useDispatch();
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const handleServerProperties = (fieldName, value) => {
    setServerProperties({ ...serverProperties, [fieldName]: value })
    validateFormFields({ ...serverProperties, [fieldName]: value },
      setFieldNameEmptyError, fieldName, fieldNameEmptyError)
  }

  const handleServerAuthCredentials = (fieldName, value) => {
    setServerAuthCredentials({ ...serverAuthCredentials, [fieldName]: value })
  }

  const handleEnabled = () => {
    setEnabled(!enabled);
  }

  const clearErrorMessages = (certificate) => {
    if (certificate === SERVER_CERTIFICATE) {
      setServerFile({ ...serverFile, error: false });
      setIsFileValidationServer(false);
      setFileValidationMessageServer('');
    } else if (certificate === CLIENT_CERTIFICATE) {
      setClientFile({ ...clientFile, error: false });
      setIsFileValidationClient(false);
      setFileValidationMessageClient('');
    }
  };

  const isValidFile = (file, certificate) => {
    if (file.size > MAX_FILE_SIZE) {
      if (certificate === SERVER_CERTIFICATE) {
        serverFile.error = true;
        setIsFileValidationServer(true);
        setFileValidationMessageServer(intl.getI18nMessage("lable.email.settings.file.upload.error"))
      } else if (certificate === CLIENT_CERTIFICATE) {
        clientFile.error = true;
        setIsFileValidationClient(true);
        setFileValidationMessageClient(intl.getI18nMessage("lable.email.settings.file.upload.error"))
      }
      return false;
    } else {
      return true;
    }
  };

  const fileLoad = (file, certificate) => {
    const reader = new FileReader();
    reader.onabort = () => {
      if (certificate === SERVER_CERTIFICATE) {
        serverFile.error = true;
        setServerFile({ ...serverFile });
      } else if (certificate === CLIENT_CERTIFICATE) {
        clientFile.error = true;
        setClientFile({ ...clientFile });
      }
    };
    reader.onerror = () => {
      if (certificate === SERVER_CERTIFICATE) {
        serverFile.error = true;
        setServerFile({ ...serverFile });
      } else if (certificate === CLIENT_CERTIFICATE) {
        clientFile.error = true;
        setClientFile({ ...clientFile });
      }
    };
    reader.onload = () => {
      if (isValidFile(file, certificate)) {
        if (certificate === SERVER_CERTIFICATE) {
          serverFile.error = false;
          setIsFileValidationServer(false);
          setFileValidationMessageServer('');
        } else if (certificate === CLIENT_CERTIFICATE) {
          clientFile.error = false;
          setIsFileValidationClient(false);
          setFileValidationMessageClient('');
        }
        const fileContent = reader.result;
        const fileExtenstion = getFileExtension(file.name);
        const fileData = file;
        fileData.ext = fileExtenstion;
        fileData.blob = new Blob(
          [fileContent],
        );
        if (certificate === SERVER_CERTIFICATE) {
          serverFile.files = [fileData];
          setServerFile({ ...serverFile });
          setServerProperties({
            ...serverProperties, certificateName: serverFile?.files[0]?.path,
            certificateContent: fileContent,
          })
        } else if (certificate === CLIENT_CERTIFICATE) {
          clientFile.files = [fileData];
          setClientFile({ ...clientFile });
          setClientCertificatePayload({
            ...clientCertificatePayload,
            certificateName: clientFile?.files[0]?.path, certificateContent: fileContent,
          })
        }
      }
    };
    reader.readAsDataURL(file);
  };

  const handleServerFiles = (files) => {
    clearErrorMessages(SERVER_CERTIFICATE);
    if (isArray(files)) {
      files.forEach((file) => {
        fileLoad(file, SERVER_CERTIFICATE);
      });
    } else {
      fileLoad(files, SERVER_CERTIFICATE);
    }
  };

  const handleClientFiles = (files) => {
    clearErrorMessages(CLIENT_CERTIFICATE);
    if (isArray(files)) {
      files.forEach((file) => {
        fileLoad(file, CLIENT_CERTIFICATE);
      });
    } else {
      fileLoad(files, CLIENT_CERTIFICATE);
    }
  };

  const onRemoveServerFile = () => {
    setServerFile({ ...serverFile, files: [] })
    setServerProperties({ ...serverProperties, certificateName: emailSettingsDetails.serverProperties.certificateName || "", certificateContent: "" })
  };

  const onRemoveClientFile = () => {
    setClientFile({ ...clientFile, files: [] })
    setClientCertificatePayload({ ...clientCertificatePayload, certificateName: "", certificateContent: "" })
  };

  const clientCertificateSuccess = useSelector((state) => getClientCertificateSuccess(state))


  const handleUpdateEmailSettings = () => {
    const updateSettingsPayload =
      convertFormDataToPayload(formData);

    if ((!serverProperties.clientCertUuid || serverProperties.clientCertUuid === "0") && serverProperties.sslAuthType === EMAIL_SETTINGS_RADIO_MUTUAL) {
      setAliasFieldNameError(true);
    } else if (clientFile.files.length > 0 && (serverProperties.clientCertUuid && serverProperties.clientCertUuid !== "0")
      && serverProperties.sslAuthType === EMAIL_SETTINGS_RADIO_MUTUAL) {
      setAliasFieldNameError(false);
      dispatch(validateClientCertificate(clientCertificatePayload,
        serverProperties.clientCertUuid));
    } else {
      setAliasFieldNameError(false);
      dispatch(createEmailSettings(updateSettingsPayload));
    }
  }

  useEffect(() => {
    if (clientCertificateSuccess) {
      const filteredPayload =
        convertFormDataToPayload(formData);
      dispatch(createEmailSettings(filteredPayload));
      dispatch(fetchEmailSettingsCertificates());
    }
  }, [clientCertificateSuccess])

  useEffect(() => {
    dispatch(fetchEmailSettingsDetails());
    dispatch(fetchEmailSettingsCertificates());
  }, [])

  const isClientCertificateErrorInDialog = clientCertificateErrorCode === "4222" && clientCertificateErrorMessage;
  const isClientCertificateErrorInAlert = clientCertificateErrorCode === "4221" && clientCertificateErrorMessage;

  useEffect(() => {
    if (emailSettingsError || isClientCertificateErrorInDialog) {
      setShowDialog(true);
    } else {
      setShowDialog(false);
    }

    if (emailSettingsValidationError || inValidClientCertificateError ||
      isClientCertificateErrorInAlert) {
      setShowAlert({
        show: true,
        variant: "error",
        message: emailSettingsValidationError || inValidClientCertificateError ||
          clientCertificateErrorMessage,
      })
    } else if (emailSettingsSuccessMessage) {
      setShowAlert({
        show: true,
        variant: "success",
        message: emailSettingsSuccessMessage,
      })
    }
  }, [emailSettingsError, emailSettingsValidationError, clientCertificateErrorMessage,
    inValidClientCertificateError, emailSettingsSuccessMessage])

  useEffect(() => {
    if (emailSettingsDetails) {
      setEnabled(emailSettingsDetails.enabled);
      const protocol = emailSettingsDetails.serverProperties.protocol;
      const sslAuthType = emailSettingsDetails.serverProperties.sslAuthType;
      setServerProperties({
        ...serverProperties,
        host: emailSettingsDetails.serverProperties.host,
        port: emailSettingsDetails?.serverProperties?.port?.toString(),
        defaultSenderAddress: emailSettingsDetails.serverProperties.defaultSenderAddress,
        protocol: protocol || EMAIL_SETTINGS_BUTTON_SMTP,
        sslAuthType: sslAuthType || EMAIL_SETTINGS_RADIO_SERVER,
        defaultSenderName: emailSettingsDetails.serverProperties.defaultSenderName,
        bounceAddress: emailSettingsDetails.serverProperties.bounceAddress,
        verificationEmail: emailSettingsDetails.serverProperties.verificationEmail,
        clientCertUuid: emailSettingsDetails.serverProperties.clientCertUuid,
        certificateName: emailSettingsDetails.serverProperties.certificateName,
      })
      setServerAuthCredentials({
        username: "",
        password: "",
        type: "BASICAUTH",
      })
    }
  }, [emailSettingsDetails])

  const handleCancelDialog = () => {
    if (clientCertificateErrorCode !== "4222") {
      dispatch(fetchEmailSettingsDetails());
    }
    serverProperties.certificateContent = "";
    setShowDialog(false);
  }

  const handleSaveDialog = () => {
    if (clientCertificateErrorCode === "4222") {
      dispatch(replaceClientCertificate(clientCertificatePayload, serverProperties.clientCertUuid));
    } else {
      const filteredPayload = convertFormDataToPayload(formData);
      dispatch(replaceEmailSettings(filteredPayload));
      setShowDialog(false);
    }
  }

  const getDialogMessages = (emailSettingsError, clientCertificateErrorMessage) => {
    if (emailSettingsError === "Invalid host") {
      return intl.getI18nMessage("label.email.settings.invalid.host.error.helptext");
    }
    if (isClientCertificateErrorInDialog) {
      return clientCertificateErrorMessage;
    }
    return emailSettingsError;
  };
  
  const isPortalAdmin = useSelector((state) => getIsPortalAdmin(state));

  useEffect(() => {
    if(!isPortalAdmin) {
      history.push('/404')
    }
  }, [isPortalAdmin])

  return (
    <div className={classes.root}>
      <Typography data-apim-test="email-settings-title" variant='h1'>{intl.getI18nMessage("label.email.settings.title")}</Typography>
      {
        isLoading &&
        <Loading pageLoader />
      }
      {
        emailSettingsDetails?.status && enabled &&
        <Box className={classes.warning}>
          {
            emailSettingsDetails?.status === "ACTIVE" ?
              <Box className={classes.flexNonBetween}>
                <CheckCircleIcon />
                <Typography data-apim-test='email-settings-active' className={classes.warningText}>{intl.getI18nMessage("label.email.settings.connection.active")}</Typography>
              </Box> :
              <Box className={classes.flexNonBetween}>
                <WarningIcon />
                <Typography data-apim-test='email-settings-in-active' className={classes.warningText}>{intl.getI18nMessage("label.email.settings.connection.in.active")}</Typography>
              </Box>
          }
        </Box>
      }
      <CreatePageContent
        intl={intl}
        handleServerProperties={handleServerProperties}
        serverProperties={serverProperties}
        handleEnabled={handleEnabled}
        enabled={enabled}
        classes={classes}
        handleServerFiles={handleServerFiles}
        isFileValidationServer={isFileValidationServer}
        fileValidationMessageServer={fileValidationMessageServer}
        serverFile={serverFile}
        onRemoveServerFile={onRemoveServerFile}
        onRemoveClientFile={onRemoveClientFile}
        handleServerAuthCredentials={handleServerAuthCredentials}
        serverAuthCredentials={serverAuthCredentials}
        handleUpdateEmailSettings={handleUpdateEmailSettings}
        emailSettingsDetails={emailSettingsDetails}
        fieldNameEmptyError={fieldNameEmptyError}
        certificatesData={certificatesData}
        setShowCsr={setShowCsr}
        handleClientFiles={handleClientFiles}
        isFileValidationClient={isFileValidationClient}
        fileValidationMessageClient={fileValidationMessageClient}
        clientFile={clientFile}
        aliasFieldNameError={aliasFieldNameError}
        history={history}
      />

      <GenerateCsrCertificate
        setShowCsr={setShowCsr}
        showCsr={showCsr}
        classes={classes}
      />

      <FormDialog
        isOpen={showDialog}
        title={intl.getI18nMessage("warning.status")}
        cancelText={intl.getI18nMessage("label.cancel.button")}
        submitText={`${isClientCertificateErrorInDialog ? intl.getI18nMessage("label.dialog.unsaved.changes.submit") : intl.getI18nMessage("label.save.button")}`}
        onCancel={handleCancelDialog}
        onSubmit={handleSaveDialog}
      >
        {
          getDialogMessages(emailSettingsError, clientCertificateErrorMessage)
        }
      </FormDialog>

      {
        showAlert.show &&
        <AlertMessages
          variant={showAlert.variant}
          message={showAlert.message}
          onClose={() => {
            setShowAlert({
              ...showAlert,
              show: false,
            });
          }}
        />
      }
    </div>
  )
}

export default EmailSettings;
